import React, { useState } from 'react';
import CreateDesignation from './CreateDesignation';
import AssignDesignation from './AssignDesignation';

const SitePlannerTabs = () => {
  const [activeTab, setActiveTab] = useState('CreateDesignation');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="p-4 rounded-lg flex flex-col items-center">
      <h1 className="text-center text-4xl font-bold mb-8 text-gray-700">SITE PLANNER INPUTS</h1>
      <ul className="tabs flex mb-4">
        <li
          className={`cursor-pointer py-2 px-4 rounded-l-lg ${activeTab === 'CreateDesignation' ? 'bg-[#424752] text-white' : 'bg-white text-[#424752]'} shadow-md hover:bg-gray-600 hover:text-white transition duration-300`}
          onClick={() => handleTabClick('CreateDesignation')}
        >
          Tab 1: Create Designations
        </li>
        <li
          className={`cursor-pointer py-2 px-4 rounded-r-lg ${activeTab === 'AssignDesignation' ? 'bg-[#424752] text-white' : 'bg-white text-[#424752]'} shadow-md hover:bg-gray-600 hover:text-white transition duration-300`}
          onClick={() => handleTabClick('AssignDesignation')}
        >
          Tab 2: Assign FDN Addresses
        </li>
      </ul>
      <div className="tab-content w-full p-6 bg-gray-100 rounded-lg ">
        {activeTab === 'CreateDesignation' && <CreateDesignation />}
        {activeTab === 'AssignDesignation' && <AssignDesignation />}
      </div>
    </div>
  );
};

export default SitePlannerTabs;
